//export const API_ENDPOINT = 'http://localhost:8300/api'
export const API_ENDPOINT = 'https://api.goongram.com/api'
